import React, { useState } from 'react';
import TableParent from "../../../adminpanel/components/commonComponents/TableParent";
import CallAPI from '../../../adminpanel/components/commonComponents/AxiosHelper';
import Form from '../../../adminpanel/components/commonComponents/Form';
import { ReportModal, ModalSubmission, ModalDropDownEvent } from "../../components/ReportComponents/ReportModal";
import ModalComponent from '../../../adminpanel/components/commonComponents/ModalComponent';
import CalenderComponent from '../commonComponents/CalenderComponent';

var customMenu = {}, columnData = [], firstColumnField = ''

const MonitoringTableDataComponent = (props) => {
    const [modalToView, setmodalToView] = useState({})

    let currentTab = props.currentTab
    let authData = props.allProps.authData
    let isCustomReportingTrue =authData? JSON.parse(authData.extraInfo)?.customReporting ? JSON.parse(authData.extraInfo)?.customReporting :false:null
    let reportsInfo = props.reportsInfo?.information ? props.reportsInfo?.information : []
    let reportDates = { "startDate": props.defaultStartDate, "endDate": props.defaultEndDate }
    let tabIdName = props.allStates.tabId
    const handleBreakdown = (value = null) => {
        let selectedField = gridOptions.api.getSelectedNodes()[0]['data']
        if (value != 'period') {
            props.handleTab(value, selectedField)
        }
    }
    const downloadReport = (e) => {
        if (gridOptions.api.getSelectedNodes().length > 0) {
            if (gridOptions.api.getSelectedNodes().length == 1) {
                var rowId = gridOptions.api.getSelectedNodes()[0].data.report_id
                let params = {
                    siteId: authData.siteId,
                }
                let userId = encodePassword(authData.userId)
                let url = '/app/download_data_quality_report';
                let postBody = { 'isReporting': true, 'rm_request_id': rowId, userId: userId }
                let responseType = "blob";
                CallAPI('POST', url, postBody, params, 0, function (response) {
                    if (response.error_code !== 404) {
                        if (responseType == "blob") {
                            alert("Your report will be opened soon in new tab")
                            let binaryData = [];
                            binaryData.push(response);
                            let fileURL = window.URL.createObjectURL(new Blob(binaryData, response.type == 'application/pdf' ? { type: 'application/pdf' } : { type: 'text/csv;charset=utf-8;' }))
                            window.open(fileURL);
                        } else {
                            var a = document.createElement("a");
                            a.href = response;
                            a.setAttribute("download", response);
                            a.click();
                        }
                    } else {
                        alert("Something Went Wrong!")
                    }
                    jQuery(`#downloadReportModal`).modal('toggle');
                }, authData, responseType);
            } else {
                alert("Please Select Only One Report!")
            }
        } else alert('Please Select Reports!')
    }
    const scheduleReport = (e) => {
        if (gridOptions.api.getSelectedNodes().length > 0) {
            var rowData = gridOptions.api.getSelectedNodes().map((innerData) =>
                innerData.data)
            if (e == "multiple") {
                if (gridOptions.api.getSelectedNodes().length > 1) {
                    const isDashboardReportSelected = rowData.some((o) => o.componentType != 'adhoc-report');
                    if (isDashboardReportSelected) {
                        alert("Please select custom reports to perform this action!")
                    } else {
                        ReportModal(rowData, setmodalToView, 'scheduleReport')
                    }
                }
            }
            else {
                if (gridOptions.api.getSelectedNodes().length == 1) {
                    if (rowData[0].componentType == 'adhoc-report') {
                        ReportModal(rowData, setmodalToView, 'scheduleReport')
                    } else {
                        alert("Please select custom reports to perform this action!")
                    }
                } else {
                    alert("Please Select Only One Report!")
                }
            }
        }
        else alert('Please select reports!')
    }
    const sharedReport = () => {
        var rowData = gridOptions.api.getSelectedNodes().map((innerData) =>
            innerData.data)
        ReportModal(rowData, setmodalToView, 'shareUser')
    }
    const manageUser = (e) => {
        var rowData = gridOptions.api.getSelectedNodes().map((innerData) =>
            innerData.data)
        props.handleRightClickOption(rowData[0], null, null,e,)
    }
    const subscribeReport = (e) => {
        var startDate = reportDates.startDate ? reportDates.startDate : reportDates.dates?.defaultStartDate
        var endDate = reportDates.endDate ? reportDates.endDate : reportDates.dates?.defaultEndDate

        var rowData = gridOptions.api.getSelectedNodes().map((innerData) =>
            innerData.data)
        var rowId = rowData.map(innerData => innerData.report_id)
        // if (e != "multiple" && gridOptions.api.getSelectedNodes().length == 1) {

        // if (gridOptions.api.getSelectedNodes().length == 1) {
        let postData = {
            'userId': encodePassword(authData.userId),
            'reportId': rowId,
            'isSubscribed': (e === "unsubscribe" ? 0 : 1),
            'rockmetric_update': true,
            'rockmetric_update_columns': ['isSubscribed']
        }
        let params = {
            siteId: authData.siteId
        }
        CallAPI('POST', '/app/updateReportSubscription', postData, params, 0, function (response) {
            let res = Object.values(response)
            if (res[0]?.status == true) {
                if (e == 'subscribe') {
                    alert(`Report Subscribed Succesfully!`)
                } else {
                    alert('Report Unsubscribed Succesfully!')
                }
                props.getReportsData();

            } else {
                alert(response[0].information)
            }
            // jQuery(`#subscriptionReportModal`).modal('toggle');
        }, authData);
        // } else {
        //     alert("Please select only one Report!")
        // }
        // // } else if (gridOptions.api.getSelectedNodes().length > 0) {
        // //     const isDashboardReportSelected = rowData.some((o) => o.componentType != 'adhoc-report');
        // //     if (isDashboardReportSelected) {
        // //         alert("Please select custom reports to perform this action!")
        // //     } else {
        // //         ReportModal(rowData, setmodalToView, 'subscribeReport');
        // //     }
        // // }

        // else alert('Please select reports!')

    }
    const modalSubmission = (e) => {
        ModalSubmission(e, props.reportsInfo, authData, modalToView, setmodalToView, props.getReportsData, reportDates)
    }
    const activateReport = () => {
        if (gridOptions.api.getSelectedNodes().length > 0) {
            var rowData = gridOptions.api.getSelectedNodes().map((innerData) =>
                innerData.data)
            ReportModal(rowData, setmodalToView, 'activateReport');
        } else {
            alert("Please Select Reports!")
        }
    }
    const requestReportApi = (reportURL, rowData) => {
        let startDate = props.defaultStartDate ? props.defaultStartDate.split('%')[0] : null;
        let endDate = props.defaultEndDate ? props.defaultEndDate.split('%')[0] : null;
        let params = {
            siteId: authData.siteId,
            toolId: props.allProps.dataSet.toolId,
            auth: "system"
        };
        let reportId = reportURL
        if (typeof reportId === 'string') {
            reportId = [reportURL]
        }
        let data = {
            "api_request": true,
            "user": authData.userId,
            "id": reportId,
            "startDate": startDate,
            "endDate": endDate,
            "sendToAll": true,
            "toolId": rowData.toolId,
            "type": rowData?.componentType == "adhoc-report" ? "report" : "dashboard"
        }
        let url = '/app/system/generate_report_v2'
        CallAPI('POST', url, data, params, 0, function (response) {
            if (response[0].status.status == true) {
                alert(response[0].status.information)
                // window.open('/requestLogs/app')
                props.getReportsData(null, startDate, endDate);
            } else {
                alert(response.error_message)
            }
        }, authData)
    }
    const requestReportAction = (e) => {
        var isDashboardReportSelected;
        if (gridOptions.api.getSelectedNodes().length == 0 && e.rowData == undefined) {
            alert("No Reports Selected ! Please Select Reports To Perform This Action.")
        } else {
            // if (gridOptions.api.getSelectedNodes().length > 0) {
            //     var rowData = gridOptions.api.getSelectedNodes().map((innerData) =>
            //         innerData.data)
            //     isDashboardReportSelected = rowData.some((o) => o.type != 'adhoc-report');
            // } else {
            var rowData = e.rowData
            // }


            let selectedReports = gridOptions.api.getSelectedNodes()
            var requestStatus = selectedReports.map((innerData) => innerData.data.reportStatus)
            if (requestStatus.includes('generated') || requestStatus.includes('requested')) {
                if (e == 'multiple') {
                    alert("Please deselect reports that have already been Requested!")
                } else {
                    alert('This Report has already been Requested!')
                }
            } else {
                // var reportUrl = e === 'multiple' ? rowData.map((innerData) => innerData.reportId) : typeof e.rowData === 'object' ? rowData.reportId : rowData[0].reportId
                var reportUrl = rowData.report_id
                requestReportApi(reportUrl != undefined ? reportUrl : rowData.report_id != undefined ? rowData.report_id : rowData[0].report_id, rowData)
            }
        }



    }
    const handleModalDropDown = (e) => {
        ModalDropDownEvent(e, modalToView, setmodalToView);
    }
    const restrictMenuOption = (params, actionArray) => {
        let disabledFlag = false
        let syncFlag = false
        let isAdmin = window.location.pathname.includes('admin')
        const menuOption = {
            name: "openReport",
            name2: "downloadReport",
            name3: "scheduleReport",
            name4: "subscribeReport",
            name5: "shareUser",
            name6: "dashboards",
            name7: 'unsubscribeReport'
        }
        if (syncFlag === false) {
            if (actionArray.name == menuOption.name2) {
                disabledFlag = true
            }
            if (actionArray.name == menuOption.name3 || actionArray.name == menuOption.name4 || actionArray.name == menuOption.name7 || actionArray.name == menuOption.name5) {
                if (params.data?.componentType == null) {
                    disabledFlag = true
                }
            }
            if (actionArray.name == menuOption.name6 && params.data.componentType == "adhoc-report") {
                disabledFlag = true
            }
        }
        if (isAdmin != true) {
            if (actionArray.name == menuOption.name3 || actionArray.name == menuOption.name5) {
                disabledFlag = true
            }
        }
        if (params.data?.isSubscribed == 0) {
            if (actionArray.name == menuOption.name7) {
                disabledFlag = true
            }
        } else if (params.data?.isSubscribed == 1) {
            if (actionArray.name == menuOption.name4) {
                disabledFlag = true
            }
        }
        if (params.data.reportStatus == "generated") {
            disabledFlag = false
        }
        return disabledFlag;

    }
    const addIcon = (params) => {
        var mainLabel = params.column.colDef.field;
        var value;
        let cellValue = JSON.parse(params.data[mainLabel])
        if (mainLabel == 'frequency') {
            if (cellValue != undefined && cellValue != "") {
                if (mainLabel == 'frequency' && params.colDef.headerName == 'Frequency') {
                    if (cellValue['freq_type'] == 'dates') {
                        value = '-'
                    } else {
                        let dayofMonth = cellValue['freq_type'] ? cellValue['freq_type'] : "";
                        if (dayofMonth == "") {
                            value = '-'
                        }
                        else {
                            value = ` ${dayofMonth != "" ? `<i class="far fa-calendar fa-lg mg-r-5"></i>${dayofMonth.charAt(0).toUpperCase() + dayofMonth.slice(1)} ` : ""}`
                        }
                    }
                }

                if (mainLabel == 'frequency' && params.colDef.headerName == 'Frequency Time') {
                    let time = cellValue['timeOfDay'] ? cellValue['timeOfDay'] : "";
                    if (time == "") {
                        value = '-'
                    } else
                        value = `${time !== "" ? ` <i class="far fa-clock fa-lg mg-r-5"></i>${time} ` : ""} `
                }
                return value
            }
            else {
                return 'Not Applied'
            }
        } else {
            let subscribeStatus = cellValue == 0 ? 'Unsubscribed' : "Subscribed"
            value = cellValue == 0 ? `${`<span><i class="fas fa-bell-slash"></i>  ${subscribeStatus}</span>  `} ` : `${`<span><i class="fas fa-bell"></i>  ${subscribeStatus}</span>  `}`
            return value
        }
    }
    const handleFastDateChanges = (e) => {
        let text = e.target.innerText.toLowerCase();
        switch (text) {
            case "original date":
                var temp_start_Date = temp_end_Date = null;
                break;
            case "last day":
                var temp_start_Date = moment(maxDateCalendar, 'YYYY-MM-D');
                var temp_end_Date = moment(maxDateCalendar, 'YYYY-MM-D');
                break;
            case "last 3 day":
                var temp_max_date = moment(maxDateCalendar, 'YYYY-MM-D').subtract(1, 'day');
                var temp_start_Date = moment(temp_max_date, 'YYYY-MM-D').subtract(3, 'day');
                var temp_end_Date = moment(temp_max_date, 'YYYY-MM-D');
                break;
            case "last week":
                var temp_max_date = moment(maxDateCalendar, 'YYYY-MM-D').subtract(1, 'day');
                var temp_start_Date = moment(temp_max_date, 'YYYY-MM-D').startOf('week');
                var temp_end_Date = moment(temp_max_date, 'YYYY-MM-D');
                break;
            case "last 15 days":
                var temp_max_date = moment(maxDateCalendar, 'YYYY-MM-D').subtract(1, 'day');
                var temp_start_Date = moment(temp_max_date, 'YYYY-MM-D').subtract(15, 'day');
                var temp_end_Date = moment(temp_max_date, 'YYYY-MM-D');
                break;
            case "this month":
                var temp_start_Date = moment().startOf("month");
                var temp_end_Date = moment();
                break;
            case "last month":
                var temp_start_Date = moment(maxDateCalendar).subtract(1, 'month').startOf("month");
                var temp_end_Date = moment(maxDateCalendar).subtract(1, 'month').endOf("month");
                break;
            case "today":
                var temp_start_Date = moment();
                var temp_end_Date = moment();
                break;
            case "yesterday":
                /* Deprecation warning: moment().subtract(period, number) is deprecated. Please use moment().subtract(number, period) */
                var temp_start_Date = moment().subtract(1, 'day');
                var temp_end_Date = moment().subtract(1, 'day');
                break;
            case "this week":
                var temp_start_Date = moment().startOf('week').add(1, 'day');
                var temp_end_Date = moment();
                break;
            case "last 3 month":
                var temp_start_Date = moment(maxDateCalendar, 'YYYY-MM-D').subtract(2, 'month').startOf("month");
                var temp_end_Date = moment(maxDateCalendar).endOf("month");
                // var temp_start_Date = moment().subtract('month',3).startOf("month");
                // var temp_end_Date = moment().subtract('month',1).endOf("month");
                break;
            case "last 6 month":
                var temp_start_Date = moment(maxDateCalendar, 'YYYY-MM-D').subtract(5, 'month').startOf("month");
                var temp_end_Date = moment(maxDateCalendar).endOf("month");
                // var temp_start_Date = moment().subtract('month',6).startOf("month");
                // var temp_end_Date = moment().subtract('month',1).endOf("month");
                break;
            case "last 13 month":
                var temp_start_Date = moment(maxDateCalendar, 'YYYY-MM-D').subtract(12, 'month').startOf("month");
                var temp_end_Date = moment(maxDateCalendar, 'YYYY-MM-D').endOf("month");
                // var temp_start_Date = moment().subtract('month',13).startOf("month");
                // var temp_end_Date = moment().subtract('month',1).endOf("month");
                break;
            case "last 1 year":
                var temp_start_Date = moment(maxDateCalendar, 'YYYY-MM-D').subtract(11, 'month').startOf("month");
                var temp_end_Date = moment(maxDateCalendar).endOf("month");
                // var temp_start_Date = moment().subtract('month',12).startOf("month");
                // var temp_end_Date = moment().subtract('month',1).endOf("month");
                break;
            case "last 2 year":
                var temp_start_Date = moment(maxDateCalendar, 'YYYY-MM-D').subtract(23, 'month').startOf("month");
                var temp_end_Date = moment(maxDateCalendar).endOf("month");
                // var temp_start_Date = moment().subtract('month',24).startOf("month");
                // var temp_end_Date = moment().subtract('month',1).endOf("month");
                break;
            case "last 3 year":
                var temp_start_Date = moment(maxDateCalendar, 'YYYY-MM-01').subtract(35, 'month').startOf("month");
                var temp_end_Date = moment(maxDateCalendar).endOf("month");
                // var temp_start_Date = moment().subtract('month',36).startOf("month");
                // var temp_end_Date = moment().subtract('month',1).endOf("month");
                break;
            case "mtd":
                var temp_start_Date = moment(maxDateCalendar).startOf("month");
                var temp_end_Date = moment(maxDateCalendar).subtract(1, 'day');
                // var temp_start_Date = moment().startOf("month");    // Get the start of current month
                // var temp_end_Date = moment().subtract('day',1);   // Get Yesterday's date                
                break;
            case "ytd":
                var temp_start_Date = '';
                fyMonth = parseInt(props.allProps.setFiscalYear);
                if (fyMonth) {
                    let currentYear = moment(maxDateCalendar).format('YYYY');  // Get the current year
                    let currentMonth = moment(maxDateCalendar).format('MM');    // Get the current month
                    currentMonth = parseInt(currentMonth);
                    if (currentMonth < fyMonth) {        // If current month is < than fyMonth then go to prev year
                        currentYear = currentYear - 1;
                    }
                    // Passing 'fyMonth-1' to currentMonth because month start from 0 in moment. Ref. link https://momentjs.com/docs/#/parsing/array/
                    currentMonth = fyMonth - 1; // Always start with fyMonth
                    currentYear = parseInt(currentYear);
                    let startDate = moment([currentYear, currentMonth, 1]);
                    temp_start_Date = moment(startDate).startOf('month');   // Start of the fiscal month
                } else {
                    temp_start_Date = moment(maxDateCalendar).startOf("year"); // Get start of the year.
                }
                var temp_end_Date = moment(maxDateCalendar);   // Get Yesterday's date
                break;
            case "wtd":
                var temp_start_Date = moment(maxDateCalendar, 'YYYY-MM-D').startOf('week');
                var temp_end_Date = moment(maxDateCalendar, 'YYYY-MM-D');
                break;
            case "qtd":
                var temp_start_Date = moment(maxDateCalendar, 'YYYY-MM-D').startOf('quarter');
                var temp_end_Date = moment(maxDateCalendar, 'YYYY-MM-D');
                break
            case "this year":
                var temp_start_Date = '';
                fyMonth = parseInt(fyMonth);
                if (fyMonth) {
                    let currentYear = moment().format('YYYY');  // Get the current year
                    let currentMonth = moment().format('MM');    // Get the current month
                    currentMonth = parseInt(currentMonth);
                    if (currentMonth < fyMonth) {        // If current month is < than fyMonth then go to prev year
                        currentYear = currentYear - 1;
                    }
                    // Passing 'fyMonth-1' to currentMonth because month start from 0 in moment. Ref. link https://momentjs.com/docs/#/parsing/array/
                    currentMonth = fyMonth - 1; // Always start with fyMonth
                    let startDate = moment([currentYear, currentMonth]);
                    temp_start_Date = moment(startDate).startOf('month');   // Start of the fiscal month
                } else {
                    temp_start_Date = moment().startOf("year"); // Get start of the year.
                }
                var temp_end_Date = moment();   // Get Yesterday's date
                break;
        }
        // $('#reportrange span').html(temp_start_Date.format('MM, YYYY') + ' - ' + temp_end_Date.format('MM, YYYY'));
        applyCalendar({ "startDate": temp_start_Date.format("YYYY-MM-DD"), "endDate": temp_end_Date.format("YYYY-MM-DD") })

    }
    const applyCalendar = (date = null) => {
        let regexToCheck = /[~!@#$%^&*()_+\-\=\[\]{};':"\\|,.<>\/?]+/
        let startDate = date && date['startDate']
            ? moment(date['startDate']).format('YYYY-MM-DD')
            : moment(jQuery(".startDatepicker").val(), "D MMM YYYY")
        let endDate = date && date['endDate']
            ? moment(date['endDate']).format('YYYY-MM-DD')
            : moment(jQuery(".endDatepicker").val(), "D MMM YYYY")
        if ((startDate && regexToCheck.test(startDate._i)) || (endDate && regexToCheck.test(endDate._i))) {
            alert('Please enter valid inputs!')
        } else {
            if (startDate && endDate) {
                jQuery('.myDropdownMenu').hide();
                props.getReportsData(null, startDate, endDate)
                filterToggle = false
                calendarDropDown("close");
            }
        }
    }

    let buttonColumnArray = [
        { 'label': "Status", 'value': 'Request Report', 'onClick': (e) => requestReportAction(e) }
    ]
    var moreButtonConfig = {
        "redirectButton": [{ "id": "redirectButton", "class": "", "label": "Edit", "type": "normal", "display": currentTab === "metrics" || currentTab === "dimensions" ? true : false, "action": "redirect", 'modal_id': null }],
        // "dropdownConfig": [{
        //     "id": "id", "label": "More", "type": "dropdown", "display": true,
        //     "children": [
        //         { "id": "exportCSV", "label": "Export CSV", "action": "export" },
        //     ]
        // }],
    }
    if (currentTab === "datasets") {
        columnData = [
            { label: "Size", value: "table_size" },
            { label: "Total Rows", value: "total_rows" },
            { label: "Total Columns", value: "total_cols" },
            { label: "Total Metrics", value: "metric_count" },
            { label: "Total Dimensions", value: "dimension_count" },
            { label: "Updated By", value: "updated_by", type: "text", hide: true },
            { label: "Last Updated ", value: "last_updated_time", type: "text" },
            { label: "Type", value: "type", type: "text", hide: true },
        ]
        customMenu = {
            "openDataset": {
                "name": "openDataset", "label": "Open Dataset", "action": ()=>props.handleRightClickOption(null,null,tabIdName)
            },
            "globalFilters": {
                "name": "globalFilters", "label": "Global Filter", "action": props.handleGlobalFilter
            },
            // "breakdownBy": {
            //     "name": "breakdownBy", "label": "Breakdown by",
            //     "items": {
            //         "dashboards": { "name": "dashboards", "label": "Dashboards", "action": handleBreakdown },
            //         "reports": { "name": "reports", "label": "Reports", "action": handleBreakdown }
            //     }
            // }
        }
        firstColumnField = 'name'
    } else if (currentTab === "dashboards") {
        columnData = [
            { label: "Dataset Name", value: "dataset_name", type: "text" },
            { label: "Last Updated ", value: "last_updated_time", type: "text" },
            { label: "Type", value: "type", type: "text" }
        ]
        customMenu = {
            "openDashboard": {
                "name": "openDashboard", "label": "Open Dashboard", "action": ()=>props.handleRightClickOption(null,null,tabIdName)
            },
            "breakdownBy": {
                "name": "breakdownBy", "label": "Breakdown by",
                "items": {
                    "reports": { "name": "reports", "label": "Reports", "action": handleBreakdown },
                    // "datasets": { "name": "datasets", "label": "Dataset", "action": handleBreakdown }
                }
            }
        }
        firstColumnField = 'dashboard_group'
    } else if (currentTab === "reports") {
        columnData = [
            { label: "Dashboard Name", value: "dashboard_group", type: "text" },
            { label: "Dataset Name", value: "datasetName", type: "text" },
            { label: "Last Updated ", value: "dateModified", type: "text" },
            // { label: "Last Refreshed Time ", value: "last_updated_time", }, // will set the acutal data when we get from the backend
            // { label: "Type", value: "componentType", type: "text" },
            // { label: "Owner", value: "userName", type: "text" },
        ]
        isCustomReportingTrue == true || isCustomReportingTrue == "true" ? columnData = [...columnData, { label: "Frequency", value: "frequency", type: "text" },
        { label: "Frequency Time", value: "frequency", type: "text" },
        { label: "Subscription Status", value: "isSubscribed", type: "text" },
        { label: "Status", value: "isActive", type: "text", hide: true }] : null
        customMenu = {
            "openReport": {
                "name": "openReport", "label": "Open Report", "action": ()=>props.handleRightClickOption(null,null,tabIdName)
            },
            "downloadReport": {
                "name": "downloadReport", "label": "Download", "action": downloadReport,
            },
        // "breakdownBy": {
        //     "name": "breakdownBy", "label": "Breakdown by",
        //     "items": {
            //         "dashboards": { "name": "dashboards", "label": "Dashboards", "action": handleBreakdown },
            //         "datasets": { "name": "datasets", "label": "Dataset", "action": handleBreakdown },
            //         // "period": { "name": "period", "label": "Period", "action": handleBreakdown }
            //     }
            // },
            "subscribeReport": {
                "name": "subscribeReport", "label": "Subscribe", "action": () => subscribeReport('subscribe')
            },
            "unsubscribeReport": {
                "name": "unsubscribeReport", "label": "Unsubscribe", "action": () => subscribeReport('unsubscribe')
            },
        }
        let url = window.location.href
        if (url.includes('admin')) {
            // customMenu['manageUsers'] = {
            //     "name": "manageUsers", "label": "Manage Access", "action": ()=>manageUser('manageAccess'),
            // }
            customMenu['shareUser'] = {
                "name": "shareUser", "label": "Share", "action": sharedReport,
            }
            customMenu['scheduleReport'] = {
                "name": "scheduleReport", "label": "Set Frequency", "action": scheduleReport,
            }
        }
        firstColumnField = 'reportName'
        // moreButtonConfig["dropdownConfig"] = [{
        //     'id': "dropdownButton", "label": "Actions", "type": "dropdown", "display": true,
        //     "children": [
        //         { "label": "Request", "action": () => requestReportAction("multiple") },
        //         { "label": "Schedule", "action": () => scheduleReport(gridOptions.api.getSelectedNodes().length>1? "multiple":""), 'id': "schedule" },
        //         { "label": "Subscription", "action": () => subscribeReport('multiple'), 'id': "subscribe" },
        //         // { "label": "Activation", "action": () => activateReport(), 'id': "activate" },
        //     ]
        // }]
        let filterForm = Object.keys(modalToView).length > 0
            ? <Form label_array={modalToView.formData} handle_form_drop_down={handleModalDropDown} />
            : null;
        Object.keys(modalToView).length > 0
            ? modalToView.modal['body'] = filterForm
            : null;
        var displayModal = modalToView.modal && Object.keys(modalToView.modal).length > 0
            ? <ModalComponent modalConfig={modalToView.modal} formSubmit={modalSubmission} />
            : null;
        let start_date = props.defaultStartDate != undefined ? props.defaultStartDate.split('%')[0] : props.defaultStartDate
        let end_date = props.defaultEndDate != undefined ? props.defaultEndDate.split('%')[0] : props.defaultEndDate
        var calendarComponent = <CalenderComponent startDate={start_date} endDate={end_date} noQuickOptions={false} authData={authData} type="reporting" handleApplyCalendar={applyCalendar} handleFastDateChanges={handleFastDateChanges} calendarPosition={true}/>
    }
    let url = window.location.href
    let screenWidth = $(window).width()

    let data = null
    if (props.allStates.sortValue) {
        data = {
            data: currentTab === "datasets" ? handleSortData(props.allStates.sortValue == 'de-alphabetically' ? "descending" : "ascending", props.allStates.sortValue, props.datasetData, 'name') : currentTab == 'reports' ? reportsInfo : handleSortData(props.allStates.sortValue == 'de-alphabetically' ? "descending" : "ascending", props.allStates.sortValue, props.dashboardData, 'dashboard_group')
        }
    } else {
        data = {
            data: currentTab === "datasets" ? props.datasetData : currentTab == 'reports' ? reportsInfo : props.dashboardData
        }
    }

    return (
        <>
            <div className={`d-flex  ${screenWidth > mobile_width ? url.includes('admin')  ? 'moveAdminTop justify-content-end' : "moveTop justify-content-end" : 'mg-t-5'}`} >
                {/* {calendarComponent && isCustomReportingTrue == true ||isCustomReportingTrue == "true" ? calendarComponent : null} */}
            </div>
            <div className={`pd-x-0 `} id="handle_content">
                <div className='box-no-padding mainCont'>
                    <TableParent
                        data={data}
                        columns_array={columnData}
                        filename={`${currentTab.charAt(0).toUpperCase() + currentTab.slice(1)} List`}
                        // buttonColumnArray={currentTab == 'reports' && isCustomReportingTrue == true ||isCustomReportingTrue == "true" ? buttonColumnArray : ""}
                        isReportingButton={true}
                        dropdownItemActions={true}
                        buttonConfig={moreButtonConfig}
                        firstColumn={'Name'}
                        firstColumnField={firstColumnField}
                        iconDisplay={addIcon}
                        restrictOption={restrictMenuOption}
                        rowSelection={"single"}
                        firstColumnShow={true}
                        customMenu={customMenu}
                        link={false}
                        noRowsAvailable={currentTab == 'datasets' && data.data.length == 0 || currentTab == 'dashboards' && props.dashboardData.length == 0 || currentTab == 'reports' && props.reportsInfo?.totalPages == 0}
                        loadingMessage={currentTab == 'datasets' && data.data.length== 0 ? 'No Datasets Found!' : currentTab == 'reports' ? 'No Reports Found!' : currentTab == 'dashboards' ? "No Dashboards Found!" : "No Data Found!"}
                        noFilters={true}
                        openDatasetOnDoubleClick={()=>props.handleRightClickOption(null,null,tabIdName)}
                    />
                </div>
            </div>
            {displayModal}
        </>
    )
}

export default MonitoringTableDataComponent
